export * from './IconFavoriteFilled';
